import { Link } from 'react-router-dom';

export function SettingsIndex() {
  return (
    <>
      <h3 className="fw-bold mb-4">Settings</h3>
      <div className="row g-3">
        <div className="col-sm-6">
          <Link to="/settings/job-management" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title text-green">Job Management</h5>
                <p className="card-text small text-muted">Import jobs from Manatal.</p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-sm-6">
          <Link to="/settings/ai-translation" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title text-green">AI Translation</h5>
                <p className="card-text small text-muted">
                  Edit the GPT prompts used to translate blog posts.
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
